module.exports = __webpack_public_path__ + "static/unnamed-4--6b9f7a1fde425769d919242f7f09faa4.png";